import { useEffect } from "react";
import { AppProviders } from "@/components/app-providers";
import { useSystemAlert } from "@/hooks/use-system-alert";
import AuthLayoutTemplate from "@/layouts/auth/split-layout";
import { useSubscriptionStore } from "@/stores/subscription-store/subscription-store";

export default function AuthLayout({
  children,
  title,
  description,
  ...props
}: {
  children: React.ReactNode;
  title: string;
  description?: string | null;
}) {
  const resetState = useSubscriptionStore((state) => state.resetState);
  const { isVisible: hasActiveAlert } = useSystemAlert();

  useEffect(() => {
    const resetSubscriptionState = () => {
      resetState();
    };

    return () => resetSubscriptionState();
  }, [resetState]);

  return (
    <div className={hasActiveAlert ? "pt-10" : ""}>
      <AppProviders />
      <AuthLayoutTemplate description={description} title={title} {...props}>
        {children}
      </AuthLayoutTemplate>
    </div>
  );
}
